import { Button, Layout, LoadingDots, Modal, Text } from '@loadsmart/loadsmart-ui'
import ReactDOM from 'react-dom'
import Logo from 'atoms/Logo/Logo'
import { useState } from 'react'
import { authManager } from 'common/authManager'
import { AuthProvider, getEnabledProviders, isAuthEnabled } from 'oidc/config'

const PROVIDER_DISPLAY_NAMES: Record<AuthProvider, string> = {
  okta: 'Okta',
  jumpcloud: 'JumpCloud',
}

const PROVIDERS_BY_PREFERENCE: AuthProvider[] = ['jumpcloud', 'okta']

const LoginModal = () => {
  const [isLoading, setLoading] = useState<boolean>(false)

  const signInWith = (provider: AuthProvider) => {
    authManager.signInWithRedirect(provider)
    setLoading(true)
  }

  const enabledProvidersByPreference = PROVIDERS_BY_PREFERENCE.filter(provider =>
    getEnabledProviders().includes(provider)
  )

  const root = document.getElementById('login-modal-root')
  if (!root) return null
  if (!isAuthEnabled()) return null
  if (authManager.isAuthenticated()) {
    return null
  }

  return ReactDOM.createPortal(
    <Modal id="login-modal" open>
      <Layout.Stack space="xl" align="center">
        <Logo />
        <>
          <Text variant="heading-sm">You&lsquo;ve been disconected from Kraken.</Text>

          {isLoading && <LoadingDots />}
          {!isLoading && !authManager.isAuthenticated() && (
            <Layout.Stack space="s" align="stretch">
              {enabledProvidersByPreference.map(provider => (
                <Button key={provider} onClick={() => signInWith(provider)}>
                  Login with {PROVIDER_DISPLAY_NAMES[provider]}
                </Button>
              ))}
            </Layout.Stack>
          )}
        </>
      </Layout.Stack>
    </Modal>,
    root
  )
}

export default LoginModal
